import { render, staticRenderFns } from "./WorkflowInputField.vue?vue&type=template&id=35822eeb&scoped=true&lang=pug&"
import script from "./WorkflowInputField.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowInputField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./WorkflowInputField.vue?vue&type=style&index=0&id=35822eeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35822eeb",
  null
  
)

export default component.exports